import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Checkbox,
    Select
} from '@shopify/polaris';

export function UpdateProductMetafieldFromDescriptionFieldPatternSettings(props) {

    const handlePatternPrefixChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.prefixPattern = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldNamespaceAndKeyChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldNamespaceAndKey = value;
        props.onSettingsChange(newSettings);
    }

    const handleMetafieldTypeChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.metafieldType = value;
        props.onSettingsChange(newSettings);
    }

    const onRemoveMetafieldValueWhenPatternIsNotFoundChange = (value) => {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.removeMetafieldValueWhenPatternIsNotFound = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Value pattern prefix"
                        placeholder="Value prefix"
                        helpText={
                            <span>
                                Text that precedes the value that must be extracted and set as metafield.<br />
                                For example, if the style value from "Style: Modern" must be extracted, you should specify "Style:" as prefix.
                            </span>
                        }
                        value={props.settings.prefixPattern}
                        error={props.settingsErrors["prefixPattern"]}
                        onChange={handlePatternPrefixChange}
                        autoComplete="off"
                    />
                </FormLayout>
            </Card.Section>
            <Card.Section>
                <FormLayout>
                    <TextField
                        label="Metafield Namespace and key"
                        placeholder="Namespace and key. For example mystore.custom_size"
                        helpText={
                            <span>
                                The namespace and key as they appear in your admin.
                            </span>
                        }
                        value={props.settings.metafieldNamespaceAndKey}
                        error={props.settingsErrors["metafieldNamespaceAndKey"]}
                        onChange={handleMetafieldNamespaceAndKeyChange}
                        autoComplete="off"
                    />
                    <Select
                        label="Metafield Type"
                        options={[
                            {
                                'label': 'Single line text',
                                'value': 'single_line_text_field'
                            },
                            {
                                'label': 'Multi line text',
                                'value': 'multi_line_text_field'
                            }
                        ]}
                        onChange={handleMetafieldTypeChange}
                        value={props.settings.metafieldType}
                        helpText={
                            <span>
                                The type of the metafield that will be populated.
                            </span>
                        }
                    />
                    <Checkbox
                        label="Remove metafield value when prefix is not found"
                        checked={props.settings.removeMetafieldValueWhenPatternIsNotFound}
                        onChange={onRemoveMetafieldValueWhenPatternIsNotFoundChange}
                        helpText={
                            <span>
                                The rule will remove the metafield value (if set) when the prefix is not found within the description field.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}